<template>
  <keep-alive include="swiperList">
    <router-view ></router-view>
  </keep-alive>
</template>

<script>
  export default {
    name: "Swiper",
    created() {
      if (!this.common.loginInfo.isLogin){
        this.$router.push("/login")
      }
    }
  }
</script>

<style scoped>

</style>
